import { render, staticRenderFns } from "./SectionSettingDialog.vue?vue&type=template&id=f4ccee98&scoped=true"
import script from "./SectionSettingDialog.vue?vue&type=script&lang=js"
export * from "./SectionSettingDialog.vue?vue&type=script&lang=js"
import style0 from "./SectionSettingDialog.vue?vue&type=style&index=0&id=f4ccee98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ccee98",
  null
  
)

export default component.exports